module.exports = __webpack_public_path__ + "img/n6.fcb3c332.png";